package com.shadowings.gero.domain.model

import kotlinx.serialization.Serializable
import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid

@Serializable
data class WordSelectionContent @OptIn(ExperimentalUuidApi::class) constructor(
    val hieroglyphs: String,
    val correctPhrase: String,
    val words: List<String>,
    val transliteration: String? = null,
    val soggettiCount: Int? = null,
    val oggettiCount: Int? = null,
    // Other translations that are just as right, e.g. both word orders where the target language
    // allows either ("la sorella cattiva" / "la cattiva sorella"). correctPhrase is the one shown.
    val alternativePhrases: List<String> = emptyList(),
    override val id: String = Uuid.random().toHexDashString()
) : IQuizContent, ICountableQuiz
